// Every URL of the portal. `path` is the pattern the router matches; `to` builds a link. URLs carry ids only,
// never personal data (no mobile, no name).
export const ROUTES = {
  signIn: { path: '/sign-in', to: () => '/sign-in' },
  overview: { path: '/', to: () => '/' },
  campaigns: { path: '/campaigns', to: () => '/campaigns' },
  campaignNew: { path: '/campaigns/new', to: () => '/campaigns/new' },
  campaignEdit: { path: '/campaigns/:id/edit', to: (id: string) => `/campaigns/${id}/edit` },
  campaign: { path: '/campaigns/:id', to: (id: string) => `/campaigns/${id}` },
  audiences: { path: '/audiences', to: () => '/audiences' },
  audienceNew: { path: '/audiences/new', to: () => '/audiences/new' },
  audience: { path: '/audiences/:id', to: (id: string) => `/audiences/${id}` },
  workflows: { path: '/workflows', to: () => '/workflows' },
  workflow: { path: '/workflows/:id', to: (id: string) => `/workflows/${id}` },
  approvals: { path: '/approvals', to: () => '/approvals' },
  whatsappNumbers: { path: '/channels/whatsapp', to: () => '/channels/whatsapp' },
  whatsappTemplates: { path: '/channels/templates', to: () => '/channels/templates' },
  ivr: { path: '/channels/ivr', to: () => '/channels/ivr' },
  voiceMessages: { path: '/channels/voice', to: () => '/channels/voice' },
  sms: { path: '/channels/sms', to: () => '/channels/sms' },
  images: { path: '/channels/images', to: () => '/channels/images' },
  dataSources: { path: '/data/sources', to: () => '/data/sources' },
  leads: { path: '/data/leads', to: () => '/data/leads' },
  suppression: { path: '/data/suppression', to: () => '/data/suppression' },
  lists: { path: '/data/lists', to: () => '/data/lists' },
  batches: { path: '/data/batches', to: () => '/data/batches' },
  batch: { path: '/data/batches/:id', to: (id: string) => `/data/batches/${id}` },
  vendors: { path: '/vendors', to: () => '/vendors' },
  vendor: { path: '/vendors/:id', to: (id: string) => `/vendors/${id}` },
  vendorApi: {
    path: '/vendors/:id/apis/:apiId',
    to: (id: string, apiId: string) => `/vendors/${id}/apis/${apiId}`,
  },
  lenderHub: { path: '/vendors/lender-hub', to: () => '/vendors/lender-hub' },
  hubLender: {
    path: '/vendors/lender-hub/lenders/:slug',
    to: (slug: string) => `/vendors/lender-hub/lenders/${slug}`,
  },
  events: { path: '/admin/events', to: () => '/admin/events' },
  audit: { path: '/admin/audit', to: () => '/admin/audit' },
  settings: { path: '/admin/settings', to: () => '/admin/settings' },
  users: { path: '/admin/users', to: () => '/admin/users' },
  account: { path: '/account', to: () => '/account' },
  gallery: { path: '/gallery', to: () => '/gallery' },
} as const
